<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="commodity-filters">
    <div class="select-all">
        <p-checkbox binary="true" [tabindex]='tabIndex + 1' (onChange)="toggleSelectAll($event)" label="Select All" [(ngModel)]="isSelectAllChecked"></p-checkbox>
    </div>

    <div [formGroup]="commodityForm">
        <p *ngIf="commodityError" class="error-text">When the train tab is used, at least one selection must be made on the commodity tab.</p>
        <ul>
            <li *ngFor="let commodityDetail of commodityList; let i = index;" class="{{commodityDetail.className}}">
                <span class="white-box"></span>
                <p-checkbox [tabindex]='tabIndex + (i + 2)' styleClass="commodity-checkboxes" (onChange)="checkSelectedValues($event)" label="{{commodityDetail.label}}" name="{{commodityDetail.value}}" value="Y" formControlName="{{commodityDetail.value}}"></p-checkbox>
            </li>
        </ul>
    </div>
</div>